$(document).ready(function() {
    $("a.icon__link").on("click",function(){
     const content = $(this).attr('data-html');
     const options ={
       helpers:{
         overlay: {
          opacity: 0.8,
          css: {'background-color': '#FF0000'}
         }         
       }
     };
     $.fancybox.open(content,options);
  });
});

$(window).on("load",function(){
   const amazonIframe = $("#roaRatingIframe").css("visibility");
   setTimeout(function(){
     if(amazonIframe == 'visible'){
        console.log("Hide BV reviews");
        $('[data-bv-show="rating_summary"]').attr('style', 'display: none !important');
     }
  },800);
})